import appcolors from "./constants/Colors";

const globalStyle = {
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      // margin: "10px",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey}}`,
        // boxShadow:"none !important",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginTop: 0,
    },

    "& .Mui-disabled": {
      cursor: "not-allowed",
    },
  },
  selectDropDown: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      "& .MuiOutlinedInput-input": {
        padding: "12px",
      },
      "& .MuiSelect-multiple": {
        overflow: "hidden",
        whiteSpace: "normal",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        display: "inline-block",
        verticalAlign: "middle",
        lineHeight: "1.5",
        paddingRight: "24px",
        "&:focus": {
          backgroundColor: "transparent",
        },
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey}}`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${appcolors.slateGrey} !important}`,
      },

    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginTop: 0,
    },
  },

  selectType: {
    "&.MuiFormControl-root .MuiOutlinedInput-root": {
      borderRadius: "0px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #7922D8`,
      boxShadow: "0px 4px 10px 0px #ebebeb",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #7922D8`,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid #7922D8`,
    },
  },
  customSelect: {
    "&.MuiFormControl-root .MuiOutlinedInput-root .MuiInputBase-input": {
      // padding: "9px",
      fontSize: "0.875rem",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #a1a1a1}`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #a1a1a1 !important}`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #a1a1a1 !important}`,
      },
    },
  },
  tableContainerStyle: {
    "&.MuiTableContainer-root .MuiTable-root .MuiTableHead-root": {
      backgroundColor: "primary.main",
    },
    "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: "custom.white",
      fontSize: "0.875rem",
    },

    "& .MuiTableCell-root .MuiTypography-body1 ": {
      // fontSize: "0.875rem",
    },
    "&.MuiTableContainer-root": {
      "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "primary.main",
        // borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "primary.main",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "grey.200",
      },
    },
  }
};

export default globalStyle;
